import { addToListModalStyles } from "@insite/content-library/Components/ManageShareListModal";

addToListModalStyles.modal = {
    ...addToListModalStyles.modal,

    cssOverrides: {},
};
